<div id="startScreen_link" class="target-element"></div>
<div id="startScreen_container">
    <img src="./../../../assets/start_ellipse.png" id="ellipse">
    <div class="content">

        <div class="left_side">

            
            <div class="titleContainer_responsive"> <!-- RESPONSIVE -->
                <div class="title_responsive">
                    <h1 id="namePresentationResp">Hallo! Ich bin Sangeethan</h1>
                    <span>FRONTEND</span>
                    <span>DEVELOPER</span>
                </div>
            </div>

            <div class="image_container">
                <!--<img src="./../../../assets/start/picture_1.png">-->
            </div>

            <div id="scroll_info_responsive" style="display:none;"> <!-- RESPONSIVE -->
                <div>
                    <span>Scroll</span>
                    <img src="./../../../assets/start/arrow.png" id="arrow" class="arrowAnimation">
                </div>
            </div>

        </div>

        <div class="right_side">

            <div class="title">
                <div>
                    <h1 id="namePresentation">Hallo! Ich bin Sangeethan</h1>
                    <span>FRONTEND</span>
                    <span>DEVELOPER</span>
                </div>
            </div>

            <div class="bottom_part">
                <div></div>
                <div class="scrollSection">
                    <span class="animate-scrollText" id="scrollText">SCROLL</span>
    
                    <div class="scrollBar">
                        <div class="animate-scrollBar" id="scrollBar"></div>
                    </div>
                </div>

                <div class="side_icons">
                    <div (mouseenter)="switchToLeft('gitHub')" (mouseleave)="returnToRight('gitHub')" >
                        <a href="https://github.com/SangeethanL/" target="_blank">
                            <img src="./../../../assets/start/github.png" id="gitHub">
                        </a>
                    </div>
                    <div (mouseenter)="switchToLeft('mail')" (mouseleave)="returnToRight('mail')">
                        <a (click)="webpageComponent.goToContact()">
                            <img src="./../../../assets/start/mail.png" id="mail">
                        </a>
                    </div>
                </div>
            </div>

        </div>

    </div>

</div>